// extracted by mini-css-extract-plugin
export default {"arrowContanier":"ArrowButton_arrowContanier__PThTa","arrowSvg":"ArrowButton_arrowSvg__tUl+3"};